"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sitesListStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
class SitesListStore {
    constructor() {
        this.sites = { value: [] };
        this.loadSites = async (query = { start: 0, id: 0, count: 100 }) => {
            this.sites.loading = true;
            // console.time("loadSites");
            const result = await api_1.SiteEndpoint.list.apiCall({
                query
            });
            // console.timeEnd("loadSites");
            if (api_1.isError(result)) {
                this.sites = { error: result.code };
            }
            else {
                console.log("result from Query on front end: ", result);
                this.sites = { value: result.sites };
                // console.log("this.sites from loadSites ============>>>>>>>", this.sites);
            }
        };
        this.loadSpecificSites = async (siteIds) => {
            const result = await api_1.SiteEndpoint.loadSpecificSites.apiCall(null, {
                siteIds
            });
            if (api_1.isError(result)) {
                return [];
            }
            else {
                // console.log("result from Query on front end: ", result);
                return result.sites;
            }
        };
        this.manualTest = async (query = { start: 0, id: 0, count: 100 }) => {
            this.sites.loading = true;
            // console.time('loadSites');
            const result = await api_1.SiteEndpoint.listSitesManual.apiCall({
                query
            });
            // console.timeEnd('loadSites');
            if (api_1.isError(result)) {
                this.sites = { error: result.code };
                this.sites.loading = false; //
            }
            else {
                // console.log('result from Query on front end: ', result);
                this.sites = { value: result.sites };
                this.sites.loading = false; //
                // console.log(
                //   "this.sites from manual test Query on front end: ",
                //   this.sites
                // );
            }
        };
        // C-117_UAT
        this.loadAllSitesNoRelation = async (query = { start: 0, count: 500 }) => {
            this.sites.loading = true;
            const result = await api_1.SiteEndpoint.listsallitesnorelation.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.sites = { error: result.code };
            }
            else {
                this.sites = { value: result.sites };
            }
        };
        this.loadSitesNoRelation = async (query = { start: 0, count: 100 }) => {
            this.sites.loading = true;
            // console.time("loadSitesNoRelation");
            const result = await api_1.SiteEndpoint.listsitesnorelation.apiCall({
                query
            });
            // console.log("result from query site ", result);
            // console.timeEnd("loadSitesNoRelation");
            if (api_1.isError(result)) {
                this.sites = { error: result.code };
            }
            else {
                this.sites = { value: result.sites };
                // console.log(
                //   "this.sites from load sites no relation on front end: ",
                //   this.sites
                // );
            }
        };
        this.loadDeletedSites = async (query = { start: 0, count: 100 }) => {
            this.sites.loading = true;
            // console.time('loadSitesNoRelation');
            const result = await api_1.SiteEndpoint.listdeletedsites.apiCall({
                query
            });
            // console.log("result from query deleted site ", result);
            // console.timeEnd('loadSitesNoRelation');
            if (api_1.isError(result)) {
                this.sites = { error: result.code };
            }
            else {
                this.sites = { value: result.sites };
                // console.log(
                //   "this.sites from load deleted sites on front end: ",
                //   this.sites
                // );
            }
        };
        this.loadSitesBillingBalance = async (query) => {
            this.sites.loading = true;
            const result = await api_1.SiteEndpoint.listSitesBillingBalance.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.sites = { error: result.code };
                alert("Error in loading sites");
            }
            else {
                this.sites = { value: result.sites };
            }
        };
    }
}
__decorate([
    mobx_1.observable
], SitesListStore.prototype, "sites", void 0);
__decorate([
    mobx_1.action
], SitesListStore.prototype, "loadSites", void 0);
__decorate([
    mobx_1.action
], SitesListStore.prototype, "loadSpecificSites", void 0);
__decorate([
    mobx_1.action
], SitesListStore.prototype, "manualTest", void 0);
__decorate([
    mobx_1.action
], SitesListStore.prototype, "loadAllSitesNoRelation", void 0);
__decorate([
    mobx_1.action
], SitesListStore.prototype, "loadSitesNoRelation", void 0);
__decorate([
    mobx_1.action
], SitesListStore.prototype, "loadDeletedSites", void 0);
__decorate([
    mobx_1.action
], SitesListStore.prototype, "loadSitesBillingBalance", void 0);
exports.sitesListStore = new SitesListStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-list/store.ts
// module id = 51
// module chunks = 0 1